import Creators from './actions';

const { updateComparisonTimePeriod } = Creators;

export default updateComparisonTimePeriod;
